import withBatchUpdateTasks from './withBatchUpdateTasks';
import ManageWrapper from './Wrapper';

export default withBatchUpdateTasks(ManageWrapper);



// WEBPACK FOOTER //
// ./src/component/TasksManagerList/ManageMenu/index.js